var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"toggles",on:{"click":_vm.toggles}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.icon}}),_c('span',[_vm._v(_vm._s(_vm.name))])]),(_vm.id == 1)?_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.link[0].link}}):_vm._e(),(_vm.id == 2)?_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.link[1].link}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }